import { KeyString } from '@app/core/models/custom/misc.model'

export type CustomizerModalData = {
  type: string
}

export type SpectrumCustomizerData = {
  style: string
  color: string
  placements: SpectrumPlacement[]
  id: string
  serviceType: string
  thumbnailUrls: { [key in SpectrumThumbnailPosition]: string }
}

export type SpectrumThumbnailPosition = 'north' | 'south' | 'east' | 'west'
export type SpectrumEmbroideryPlacementPosition = 'LC' | 'RS' | 'RC' | 'FC' | 'LS' | 'FR' | 'FL' | 'BC'
export type SpectrumScreenprintPlacementPosition = 'SPLC' | 'SPRS' | 'SPRC' | 'SPFC' | 'SPLS' | 'SPFR' | 'SPFL' | 'SPBC'
export type SpectrumPlacementPosition = SpectrumEmbroideryPlacementPosition | SpectrumScreenprintPlacementPosition
export const RECIPE_ID_GENERATION_ERROR = 'ERROR GENERATING RECIPE SET ID'

export type SpectrumPlacement = {
  background: string
  filter: string | null
  placement: SpectrumPlacementPosition
  service: string
  url: string
  isDigitizationRequired: boolean
  logoName: string
  assetId: number
  thumbnailUrl?: string
  thumbnailPosition?: SpectrumThumbnailPosition | null
}

export const SpectrumPlacementPositions: KeyString<string> = {
  LC: 'Left Chest',
  RS: 'Right Sleeve',
  RC: 'Right Chest',
  FC: 'Front Center',
  LS: 'Left Sleeve',
  FR: 'Front Right',
  FL: 'Front Left',
  BC: 'Back Center',
  SPLC: 'Left Chest',
  SPRS: 'Right Sleeve',
  SPRC: 'Right Chest',
  SPFC: 'Front Center',
  SPLS: 'Left Sleeve',
  SPFR: 'Front Right',
  SPFL: 'Front Left',
  SPBC: 'Back Center'
}

export const SpectrumThumbnailForPlacement: Partial<Record<string, SpectrumThumbnailPosition>> = {
  LC: 'north',
  RC: 'north',
  FC: 'north',
  FR: 'north',
  FL: 'north',
  RS: 'east',
  LS: 'west',
  BC: 'south',
  SPLC: 'north',
  SPRS: 'east',
  SPRC: 'north',
  SPFC: 'north',
  SPLS: 'west',
  SPFR: 'north',
  SPFL: 'north',
  SPBC: 'south'
}
